import React, { useCallback, useRef, useState } from "react";
import { Button, Col, Form, InputGroup, Modal, Row } from '@themesberg/react-bootstrap';
import { useCookies } from "react-cookie";
import Datetime from "react-datetime";
import moment from "moment-timezone";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { addPeriods } from "../../../../../controller/api/gamePeriod";

export default (props) => {

  const [cookies] = useCookies(['lottmekong'])

  const _onHide = () => {

    props.onHide()

  }

  const _name = useRef('');
  
  const _from = useRef();
  
  const _days = useRef(1);
  
  const _periods = useRef(191);
  
  const [daysValue, setDaysValue] = useState(1);
  
  const [periodsValue, setPeriodsValue] = useState(191);

  const _handleChangeFrom = useCallback((payload) => {
    _from.current = payload
  }, [])
  
  const _handleChangeName = useCallback((payload) => {
    _name.current = payload.target.value
  }, [])
  
  const _handleChangeDays = useCallback((payload) => {
    const value = parseInt(payload.target.value) || 1;
    _days.current = value;
    setDaysValue(value);
  }, [])
  
  const _handleChangePeriods = useCallback((payload) => {
    const value = parseInt(payload.target.value) || 191;
    _periods.current = value;
    setPeriodsValue(value);
  }, [])

  const onSubmit = async () => {
    // Truyền thông tin thô cho backend xử lý
    const resp = await addPeriods(
      cookies.lottmekong, 
      _name.current, 
      'keno', 
      moment(_from.current).format("DD/MM/YYYY"), 
      '06:08', 
      _periods.current, // số kỳ
      _days.current     // số ngày
    )
    if (resp) {
      window.location.reload()
      _onHide()
    } else {
      alert('Có lỗi xảy ra')
      return false
    }
  }

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onHide={_onHide}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Thêm kỳ quay Keno
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Row>
            <Col md={12} className="mb-2">
              <Form.Group id="firstName">
                <Form.Label>Tên kỳ</Form.Label>
                <Form.Control required type="number" placeholder="Nhập tên kỳ" onChange={_handleChangeName} />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={12} className="mb-2">
              <Form.Group id="days">
                <Form.Label>Số ngày</Form.Label>
                <Form.Control 
                  required 
                  type="number" 
                  placeholder="Nhập số ngày" 
                  defaultValue={1}
                  min={1}
                  onChange={_handleChangeDays} 
                />
                <Form.Text className="text-muted">
                  Số ngày cần tạo kỳ
                </Form.Text>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={12} className="mb-2">
              <Form.Group id="periods">
                <Form.Label>Số kỳ mỗi ngày</Form.Label>
                <Form.Control 
                  required 
                  type="number" 
                  placeholder="Nhập số kỳ mỗi ngày" 
                  defaultValue={191}
                  min={1}
                  onChange={_handleChangePeriods} 
                />
                <Form.Text className="text-muted">
                  Tổng kỳ sẽ được tạo: {daysValue * periodsValue} kỳ
                </Form.Text>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={12} className="mb-2">
              <Form.Label>Ngày</Form.Label>
              <Datetime
                timeFormat={false} 
                onChange={_handleChangeFrom}
                renderInput={(props, openCalendar, closeCalendar) => (
                  <InputGroup>
                    <InputGroup.Text><FontAwesomeIcon icon={faCalendarAlt} /></InputGroup.Text>
                    <Form.Control
                      required
                      type="text"
                      value={_from.current ? moment(_from.current).format("DD/MM/YYYY") : ""}
                      placeholder="dd/mm/yyyy"
                      onFocus={openCalendar}
                      onSubmit={closeCalendar}
                      onChange={() => { }} />
                  </InputGroup>
                )}
              />
            </Col>
          </Row>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={_onHide}>Close</Button>
        <Button variant="primary" onClick={onSubmit}>Thêm</Button>
      </Modal.Footer>
    </Modal>
  );
}
